module.exports = __webpack_public_path__ + "img/surveysays.855d98b5.jpeg";